import { lazy, Suspense } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { getHopColor } from '@/utils/getHopColor';
import { MapCardWrapper, MapStack } from '../../styles';
import type { HopType } from '../../types';

const TracerouteMap = lazy(
  () => import('@/components/MapboxMap/TracerouteMap')
);

interface MapCardProps {
  route: HopType[];
  mapped: boolean;
}

// Displays a map of the traceroute hops if mapping is enabled
export function MapCard({ route, mapped }: MapCardProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  if (!mapped) {
    return null;
  }

  const locales = route
    .filter((hop) => hop.lat !== undefined && hop.lon !== undefined)
    .map((hop) => ({
      lat: hop.lat!,
      lon: hop.lon!,
      city: hop.city || 'Unknown',
      isp: hop.isp || 'Unknown',
      color: getHopColor(hop.latency, theme),
      hop: hop.hop,
      subdiv: hop.subdivIso || '',
    }));

  return (
    <MapCardWrapper>
      <MapStack>
        <Suspense fallback={<Typography>{t('common.loading')}</Typography>}>
          <TracerouteMap locales={locales} showRoute={true} />
        </Suspense>
      </MapStack>
    </MapCardWrapper>
  );
}

export default MapCard;
